import { combineReducers } from 'redux'
import appState from './appState/reducer'
import snackBarState from './snackBarState/reducer'

export default combineReducers({
  appState,
  snackBarState
})
